import apiClient from './client'

export interface StripePackage {
  id: string
  name: string
  credits: number
  price_eur: number
  price_pln: number
}

export interface CheckoutSessionResponse {
  success: boolean
  session_url: string
  session_id: string
}

/**
 * Create Stripe Checkout session — redirects user to Stripe hosted payment page.
 * Backend: /api/stripe/create-checkout-session (backend_www.py)
 */
export async function createCheckoutSession(packageId: string): Promise<CheckoutSessionResponse> {
  const response = await apiClient.post('/stripe/create-checkout-session', {
    package_id: packageId,
  })
  return response.data
}

/**
 * Fetch available credit packages from backend config.
 * Backend: /api/stripe/packages
 */
export async function getStripePackages(): Promise<StripePackage[]> {
  try {
    const response = await apiClient.get('/stripe/packages')
    return response.data?.packages ?? []
  } catch {
    // Fallback: hardcoded defaults when backend config not yet populated
    return [
      { id: 'starter',  name: 'Starter',  credits: 50,   price_eur: 6,  price_pln: 25 },
      { id: 'standard', name: 'Standard', credits: 150,  price_eur: 15, price_pln: 60 },
      { id: 'pro',      name: 'Pro',      credits: 500,  price_eur: 35, price_pln: 150 },
    ]
  }
}
